import { Spin } from 'antd';
import type { IDocumentFormatted } from 'queries/applications/useApplicationByReferenceNumber/types';
import { OverviewPage } from 'pages/OverviewPage';
import { useCaseTasks } from 'queries/brokerCases/useCaseTasks';
import { usePrefetchDocumentReviews } from 'queries/brokerCases';

interface OoCustomerFilesPageProps {
  caseId: string;
  applicationFilesInternal?: IDocumentFormatted[];
  isBankDetailsComplete: boolean;
  onGoToEvidence: () => void;
  onGoToBankDetails: () => void;
}

export function OoCustomerFilesPage({
  caseId,
  applicationFilesInternal,
  isBankDetailsComplete,
  onGoToEvidence,
  onGoToBankDetails,
}: OoCustomerFilesPageProps) {
  const { data: caseTasksData, isLoading: isCaseTasksLoading } = useCaseTasks(caseId);
  const sections = caseTasksData?.sections ?? [];

  usePrefetchDocumentReviews(caseId, sections);

  if (isCaseTasksLoading && !caseTasksData) {
    return <Spin size='large' />;
  }

  return (
    <OverviewPage
      sections={sections}
      applicationFilesInternal={applicationFilesInternal}
      showBankDetailsTask
      isBankDetailsComplete={isBankDetailsComplete}
      onGoToEvidenceV2={onGoToEvidence}
      onGoToBankDetails={onGoToBankDetails}
    />
  );
}
